// extracted by mini-css-extract-plugin
export var deleteModal = "_sf-0";